/* Dinastía Café — interacciones de tienda: modal de producto, selector de cajas del pack,
   filtro de tueste, armador de pack y botón flotante de WhatsApp. Usa delegación de eventos
   en document para funcionar también tras las recargas de sección del editor de temas. */
(() => {
  'use strict';

  function closeDialog(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  }

  function updatePackPicker(dialog) {
    const max = Number(dialog.dataset.maxBoxes || 0);
    const rows = dialog.querySelectorAll('[data-dinastia-box-row]');
    let picked = 0;
    const parts = [];
    const notices = [];
    rows.forEach((row) => {
      const qty = Number(row.dataset.qty || 0);
      picked += qty;
      const qtyEl = row.querySelector('[data-dinastia-qty-value]');
      if (qtyEl) qtyEl.textContent = String(qty);
      row.dataset.qtyActive = qty > 0 ? 'true' : 'false';
      const capsuleNotice = row.querySelector('[data-dinastia-capsule-notice]');
      if (capsuleNotice) capsuleNotice.hidden = qty === 0;
      if (qty > 0) parts.push(qty + '× ' + row.dataset.boxName);
      // Aviso propio de la variedad (se configura por bloque en el editor de temas)
      if (qty > 0 && row.dataset.boxNotice && !notices.includes(row.dataset.boxNotice)) {
        notices.push(row.dataset.boxNotice);
      }
    });

    const noticeEl = dialog.querySelector('[data-dinastia-box-notice]');
    if (noticeEl) {
      noticeEl.textContent = notices.join(' ');
      noticeEl.hidden = notices.length === 0;
    }

    const countEl = dialog.querySelector('[data-dinastia-picker-count]');
    if (countEl) countEl.textContent = picked + ' de ' + max + ' cajas seleccionadas';

    const propsInput = dialog.querySelector('[data-dinastia-properties-input]');
    if (propsInput) propsInput.value = parts.join(' · ');

    const cta = dialog.querySelector('[data-dinastia-cta]');
    if (cta) {
      const ready = picked === max;
      cta.disabled = !ready;
      cta.textContent = ready
        ? cta.dataset.readyLabel
        : cta.dataset.pendingLabel.replace('%%n%%', String(max - picked));
    }
  }

  document.addEventListener('click', (event) => {
    // Open a dinastia quick-view dialog
    const opener = event.target.closest('[data-dinastia-open-modal]');
    if (opener) {
      event.preventDefault();
      openDialog(opener.getAttribute('data-dinastia-open-modal'));
      return;
    }

    // Close button inside a dialog
    const closer = event.target.closest('[data-dinastia-close-modal]');
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('dialog.dinastia-modal'));
      return;
    }

    // Backdrop click closes the dialog (click landed on the <dialog> element itself, not a child)
    if (event.target.matches('dialog.dinastia-modal')) {
      closeDialog(event.target);
      return;
    }

    // Pack box-picker stepper
    const stepBtn = event.target.closest('[data-dinastia-inc], [data-dinastia-dec]');
    if (stepBtn) {
      const dialog = stepBtn.closest('dialog.dinastia-modal');
      const row = stepBtn.closest('[data-dinastia-box-row]');
      if (dialog && row) {
        const max = Number(dialog.dataset.maxBoxes || 0);
        const rows = dialog.querySelectorAll('[data-dinastia-box-row]');
        let picked = 0;
        rows.forEach((r) => (picked += Number(r.dataset.qty || 0)));
        const isInc = stepBtn.hasAttribute('data-dinastia-inc');
        const current = Number(row.dataset.qty || 0);
        if (isInc && picked < max) {
          row.dataset.qty = String(current + 1);
        } else if (!isInc && current > 0) {
          row.dataset.qty = String(current - 1);
        }
        updatePackPicker(dialog);
      }
      return;
    }

    // Roast filter
    const filterBtn = event.target.closest('[data-dinastia-filter]');
    if (filterBtn) {
      const group = filterBtn.closest('[data-dinastia-filters]');
      if (!group) return;
      const value = filterBtn.getAttribute('data-dinastia-filter');
      group.querySelectorAll('[data-dinastia-filter]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn === filterBtn ? 'true' : 'false');
      });
      const grid = document.getElementById(group.getAttribute('data-dinastia-filters'));
      if (grid) {
        grid.querySelectorAll('[data-roast]').forEach((card) => {
          const show = value === 'Todos' || card.getAttribute('data-roast') === value;
          card.hidden = !show;
        });
      }
      return;
    }

    // Size builder
    const sizeBtn = event.target.closest('[data-dinastia-size]');
    if (sizeBtn) {
      const group = sizeBtn.closest('[data-dinastia-size-group]');
      if (!group) return;
      group.querySelectorAll('[data-dinastia-size]').forEach((btn) => {
        btn.classList.toggle('is-active', btn === sizeBtn);
      });
      const totalEl = group.querySelector('[data-dinastia-builder-total]');
      const perCapEl = group.querySelector('[data-dinastia-builder-percap]');
      const shipEl = group.querySelector('[data-dinastia-builder-ship]');
      const addBtn = group.querySelector('[data-dinastia-builder-add]');
      if (totalEl) totalEl.textContent = sizeBtn.dataset.total || '';
      if (perCapEl) perCapEl.textContent = sizeBtn.dataset.percap || '';
      if (shipEl) shipEl.textContent = sizeBtn.dataset.ship || '';
      if (addBtn) addBtn.setAttribute('data-dinastia-open-modal', sizeBtn.dataset.modalTarget || '');
      return;
    }
  });

  // Close the quick-view dialog on a valid add-to-cart submit. The theme's own
  // cart-drawer defers opening until the dialog the submit came from fires its
  // native `close` event (see assets/cart-drawer.js #handleCartLinesUpdate),
  // so without this the drawer would never open for adds made from our modals.
  document.addEventListener('submit', (event) => {
    const dialog = event.target.closest && event.target.closest('dialog.dinastia-modal');
    if (dialog) closeDialog(dialog);
  });

  // WhatsApp floating button visibility. On desktop (>=990px) this theme scrolls
  // .page-wrapper instead of the window, so window.scrollY never changes there —
  // listen on both and take whichever is actually scrolled.
  const waBtn = document.querySelector('[data-dinastia-whatsapp]');
  if (waBtn) {
    const pageWrapper = document.querySelector('.page-wrapper');
    const getScrollY = () => Math.max(window.scrollY, pageWrapper ? pageWrapper.scrollTop : 0);
    const onScroll = () => waBtn.classList.toggle('is-visible', getScrollY() > 380);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/* ---------------------------------------------------------------------------
   Guardia de packs (sep 2026)

   Los Packs de 30/60/90 se arman eligiendo cajas, y esa elección viaja como la
   line item property `Variedades`. Cualquier ruta que meta un pack al carrito
   sin pasar por el selector produce un pedido que nadie sabe empacar.

   La ficha de producto ya quedó cubierta por blocks/dinastia-pack-picker.liquid.
   Esto cubre el resto: las tarjetas con botón "Agregar" de los resultados de
   búsqueda, que agregaban el pack con properties vacío. Actúa en tres capas,
   porque el tema repinta esas listas por JS al filtrar y al paginar:

     1. quita el botón de agregar y oculta la tarjeta-formulario
     2. re-escanea al repintar (MutationObserver + respaldo por intervalo)
     3. intercepta click y submit en fase de captura y manda a la ficha

   Ojo: nada de esto usa requestAnimationFrame. En una pestaña en segundo plano
   rAF no corre, el re-escaneo se quedaría colgado y los botones reaparecerían.
--------------------------------------------------------------------------- */
(() => {
  'use strict';

  var PACK_VARIANT_IDS = ['52338731548974', '52338731876654', '52338732138798'];

  function isUnguardedPackForm(form) {
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return false;
    if (form.closest('dialog.dinastia-modal')) return false;
    var field = form.querySelector('[name="id"]');
    if (!field) return false;
    return PACK_VARIANT_IDS.indexOf(String(field.value)) !== -1;
  }

  function productUrlFor(form) {
    var card = form.closest('product-card, .product-card, .card, li, article') || document;
    var link = card.querySelector && card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function neutralize() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.getAttribute('data-dinastia-pack-guard') === 'done') continue;
      if (!isUnguardedPackForm(form)) continue;
      form.setAttribute('data-dinastia-pack-guard', 'done');

      // El tema agrega al carrito desde el click del botón, no desde el submit:
      // si el botón no existe, no hay nada que disparar.
      var buttons = form.querySelectorAll('button[type="submit"], button[name="add"], [type="submit"]');
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].disabled = true;
        if (buttons[j].parentNode) buttons[j].parentNode.removeChild(buttons[j]);
      }

      var target = form.closest('.quick-add') || form;
      target.style.display = 'none';
    }
  }

  var scanQueued = false;
  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () {
      scanQueued = false;
      neutralize();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neutralize);
  } else {
    neutralize();
  }

  // Los resultados de búsqueda se repintan al filtrar y al paginar por scroll.
  // El observer se guarda en una variable para que no lo recoja el recolector.
  var packGuardObserver = null;
  if (window.MutationObserver) {
    packGuardObserver = new MutationObserver(scheduleScan);
    packGuardObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  // Respaldo barato (el escaneo cuesta ~0,2 ms) por si el observer se pierde
  // algún repintado hecho fuera del DOM principal.
  var packGuardInterval = setInterval(neutralize, 1000);
  window.__dinastiaPackGuard = { observer: packGuardObserver, interval: packGuardInterval };

  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('popstate', scheduleScan);

  // Última línea de defensa, en captura sobre document para adelantarse a los
  // manejadores del tema, que viven en los elementos.
  function intercept(event) {
    var origin = event.target;
    if (!origin || !origin.closest) return;
    var form = origin.closest('form[action*="/cart/add"]');
    if (!isUnguardedPackForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var url = productUrlFor(form);
    if (url) window.location.href = url;
  }
  document.addEventListener('click', intercept, true);
  document.addEventListener('submit', intercept, true);
})();
